export default function ResetToken(email) {
  this.token = crypto.randomUUID()
  this._id = this.token
  this.email = email
  this.visited = false
  this.exhausted = false
}